export default "__VITE_ASSET__65FHbgW___"